<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { useDialogsStore } from '@/stores/dialogsStore'

import BDialog from '@/components/base/BDialog/BDialog.vue'

// Singleton message dialog (today: the "invoice copy requested" confirmation) — opens via
// dialogsStore.message; replaces @old message_dialog (ADA-4437 etapp 2). The payload's
// title/text are locale KEYS, translated here.
const { t } = useI18n()
const dialogsStore = useDialogsStore()
const model = computed({
  get: () => dialogsStore.message != null,
  set: (value) => {
    if (!value) dialogsStore.message = null
  },
})
</script>

<template>
  <b-dialog v-model="model">
    <template #title>{{ dialogsStore.message != null ? t(dialogsStore.message.title) : '' }}</template>

    <div
      v-if="dialogsStore.message != null"
      class="text-body-medium px-6 pb-4"
    >
      {{ t(dialogsStore.message.text) }}
    </div>

    <template #footer="{ closeProps }">
      <v-spacer />

      <v-btn
        v-bind="closeProps"
        color="primary"
        variant="flat"
      >
        {{ t('common.close') }}
      </v-btn>
    </template>
  </b-dialog>
</template>
